import { useState } from 'react'

/**
 * A gown's photo at list size, or the thumbnail's own ground when there is
 * none or it will not load — never the browser's broken-image icon.
 *
 * Lazy, because a catalog page is fifty rows and the photos are originals
 * today (no derivatives yet, `docs/03-third-party-media-storage.md`): only
 * the rows scrolled to are fetched. `srcSet`, when the media has variants,
 * lets the browser take the narrowest one that holds up at 40px.
 */
export function GownThumb({ src, srcSet }: { readonly src: string | undefined; readonly srcSet?: string | undefined }) {
  const [failed, setFailed] = useState(false)
  if (!src || failed) return <span className="st-thumb" aria-hidden />
  return (
    <img
      className="st-thumb"
      src={src}
      {...(srcSet ? { srcSet, sizes: '40px' } : {})}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  )
}
